import React from 'react';
import config from './config';
import IdleTimer from 'react-idle-timer';
import './App.css';
import ErrorBoundary from 'components/errorBoundary';
import Topbar from './components/topbar/TopBar';
import Sidebar from './components/sidebar/SideBar';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Terminals from './pages/terminals/Terminals';
import Staff from './pages/staff/Staff';
import Transactions from './pages/transactions/Transactions';
import Merchants from './pages/merchants/Merchants';
import Home from './pages/home/Home';
import Login from './pages/auth/Login';
import RequestLink from './pages/auth/RequestLink';
import SetPassword from './pages/auth/SetPassword';
import useToken from './components/app/useToken';
import NewMerchant from './pages/merchants/new/NewMerchant';
import EditMerchant from 'pages/merchants/edit/EditMerchant';
import NewStaff from './pages/staff/new/NewStaff';
import NewTerminal from './pages/terminals/new/NewTerminal';
import EditTerminal from 'pages/terminals/edit/EditTerminal';
import { useAuth } from 'contexts/AuthContext';
import ChangePassword from 'pages/auth/ChangePassword';
import Settings from 'pages/settings/Settings';
import Profile from 'pages/profile/Profile';
import MerchantDetail from 'pages/merchants/detail/MerchantDetail';
import TerminalDetail from 'pages/terminals/detail/TerminalDetail';
import RoleRoute from 'components/app/RoleRoute';

function App() {
  const idleTimer = React.useRef(null);
  const { token, setToken, logout } = useToken();
  const { userDetails } = useAuth();

  // The Router sits above the token check so unauthenticated users can reach
  // public routes (e.g. /request-link). Every other path falls through to Login.
  let body;

  if (!token) {
    body = (
      <Routes>
        <Route path='/request-link' element={<RequestLink />} />
        <Route path='/set-password' element={<SetPassword setToken={setToken} />} />
        <Route path='*' element={<Login setToken={setToken} />} />
      </Routes>
    );
  } else if (userDetails?.metadata?.password_reset_requested || userDetails?.must_change_password) {
    // Force a password change on first login for both staff and merchants.
    body = <ChangePassword logout={logout} />;
  } else {
    body = (
      <>
        {/* logout user after specified iactivity time in miliseconds */}
        <IdleTimer ref={idleTimer} element={document} onIdle={logout} timeout={config.TIME_OUT} />

        <ErrorBoundary>
          <div>
            <Topbar />
            <div className='container'>
              <Sidebar logout={logout} />
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/terminals' element={<Terminals />} />
                <Route path='/terminals/:id' element={<TerminalDetail />} />
                <Route path='/transactions' element={<Transactions />} />
                <Route path='/profile' element={<Profile />} />
                <Route path='/staff' element={<RoleRoute allow='staff'><Staff /></RoleRoute>} />
                <Route path='/new-staff' element={<RoleRoute allow='staff'><NewStaff /></RoleRoute>} />
                <Route path='/new-terminal' element={<RoleRoute allow='staff'><NewTerminal /></RoleRoute>} />
                <Route path='/edit-terminal/:id' element={<RoleRoute allow='staff'><EditTerminal /></RoleRoute>} />
                <Route path='/merchants' element={<RoleRoute allow='staff'><Merchants /></RoleRoute>} />
                <Route path='/merchants/:id' element={<RoleRoute allow='staff'><MerchantDetail /></RoleRoute>} />
                <Route path='/new-merchant' element={<RoleRoute allow='staff'><NewMerchant /></RoleRoute>} />
                <Route path='/edit-merchant/:id' element={<RoleRoute allow='staff'><EditMerchant /></RoleRoute>} />
                <Route path='/settings' element={<RoleRoute allow='staff'><Settings /></RoleRoute>} />
                <Route path='*' element={<Navigate to='/' replace />} />
              </Routes>
            </div>
          </div>
        </ErrorBoundary>
      </>
    );
  }

  return <Router>{body}</Router>;
}

export default App;
